import {
  avatarsControllerFindAllAuthenticated,
  type Avatar,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useQuery } from "@tanstack/react-query";

const getAvatars = async (): Promise<Avatar[]> =>
  unwrapApiResponse(
    avatarsControllerFindAllAuthenticated<true>({
      throwOnError: true,
    }),
  );

export const useGetAvatars = () =>
  useQuery({
    initialData: [],
    queryKey: ["avatars"],
    queryFn: getAvatars,
  });
